import {bootstrapApplication} from '@angular/platform-browser';
import {appConfig} from './app/app.config';
import {AppComponent} from './app/app.component';
import {register as registerSwiperElements} from 'swiper/element/bundle';
import {environment} from "./environments/environment";

const oneTrustScript = document.getElementById('onetrust-script');
if (oneTrustScript) {
  oneTrustScript.setAttribute('src', 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js');
  oneTrustScript.setAttribute('data-document-language', 'true');
  oneTrustScript.setAttribute('type', 'text/javascript');
  oneTrustScript.setAttribute('charset', 'UTF-8');
  oneTrustScript.setAttribute('data-domain-script', environment.oneTrustDomainScript);
}

registerSwiperElements();

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
